import React from 'react';
import { Box, Text, Center } from '@chakra-ui/react';
import { useImaginationRoom } from '@invitato/imagination-room';

import { useGuest } from '@/context/guest';

import useLang from '@/hooks/useLang';

import WithAnimation from '@/components/Common/WithAnimation';
import WelcomeVideo from '@/components/Section/WelcomeVideo/Lazy';

import { ENABLE_MUSLIM_LANGUAGE, ENABLE_WELCOME_VIDEO } from '@/constants/feature-flags';
import { ASSETS_KAWUNG_LOOPING } from '@/constants/assets';
import { BG_LAYER } from '@/constants/colors';
import { THE_BRIDE } from '@/constants';
import { TEXT_PROPS } from '@/constants/default-props';

import locales from './locales';
import generateShift from '@/hooks/useShift';

function WelcomeV4() {
  const { guest } = useGuest();
  const { name } = guest;
  const lang = useLang();
  const { onGetFinalName } = useImaginationRoom();

  // const isInvitation = useInvitation();
  const time = generateShift(guest.shift);

  return (
    <>
      {ENABLE_WELCOME_VIDEO && <WelcomeVideo />}
      <Box width="100%" marginTop="-8px" marginBottom="36px" position="relative">
        <Box
          pos="absolute"
          top="8px"
          left="0"
          width="10%"
          h="calc(100% + 150px)"
          bgImage={ASSETS_KAWUNG_LOOPING}
          bgSize="contain"
          bgPos="top center"
          bgRepeat="repeat-y"
          zIndex="3"
        />
        <Box width="75%" m="0 auto" zIndex="3">
          <WithAnimation>
            <Box pt="48px">
              <WithAnimation>
                <Text {...TEXT_PROPS.body} fontSize="18px" textAlign="center">
                  The Wedding of
                </Text>
                <Text
                  margin="16px 0 32px 0"
                  {...TEXT_PROPS.subHeading}
                  color="secondaryColorText"
                  textAlign="center"
                  fontWeight="bold"
                  dangerouslySetInnerHTML={{
                    __html: onGetFinalName('coupleName', THE_BRIDE)
                  }}
                />
              </WithAnimation>
            </Box>
            <Center
              borderRadius="16px"
              border="1px solid"
              borderColor="bgSecondary"
              bgColor={BG_LAYER}
              minHeight="40vh"
              padding="24px"
              my="24px"
              {...TEXT_PROPS.body}
              textAlign="center"
            >
              <Box textAlign="center" {...TEXT_PROPS.body}>
                <Box
                  {...TEXT_PROPS.body}
                  fontSize="18px"
                  color="secondaryColorText"
                  textAlign="center"
                  pb="24px"
                >
                  <Text>{locales.dear[lang]}</Text>
                  <Text fontWeight="bold">{name ? `${name}` : locales.guest[lang]}</Text>
                </Box>
                <Text>
                  {time == 'resepsi'
                    ? `"${locales.quote[lang]}"`
                    :  `"${locales.ayat[lang]}"`}
                </Text>
                <Text pt="20px" fontWeight="bold">
                  {time == 'resepsi'
                    ? `(${locales.quoteName[lang]})`
                    : `(${locales.ayatName[lang]})`}
                </Text>
              </Box>
            </Center>
          </WithAnimation>
        </Box>
      </Box>
    </>
  );
}

export default React.memo(WelcomeV4);
